(() => {
	angular
		.module('main')
		.controller('JobsOverviewController', JobsOverviewController);

	JobsOverviewController.$inject = [
		'$window',
		'$scope',
		'$rootScope',
		'$location',
		'$routeParams',
		'$timeout',
		'messageService',
		'timeService',
		'stringModifierService',
		'newJobsDataService',
		'clientService',
		'jobTypesDataService',
		'workflowDataService',
		'accountService',
		'settingsService'
	];

	function JobsOverviewController(
		$window,
		$scope,
		$rootScope,
		$location,
		$routeParams,
		$timeout,
		messageService,
		timeService,
		stringModifierService,
		newJobsDataService,
		clientService,
		jobTypesDataService,
		workflowDataService,
		accountService,
		settingsService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$('body').updatePolyfill();
			let searchFromUrl;
			try {
				searchFromUrl = decodeURIComponent($routeParams.search);
				searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
			} catch (e) {
				searchFromUrl = '';
			}
			$scope.pageRequest = {
				page: +$routeParams.page || 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,

				pageOrder: {
					predicate: $rootScope.jobPageRequest && $rootScope.jobPageRequest.pageOrder.predicate || 'startDate',
					reverse: $rootScope.jobPageRequest && $rootScope.jobPageRequest.pageOrder.reverse || false
				},
				search: searchFromUrl || ''
			};
			$scope.items = [
				{
					email: ''
				}
			];
			$scope.selectActive = [
				'Active jobs',
				'Active Jobs with Upcoming Shoots',
				'Completed jobs'
			];

			$scope.searchText = searchFromUrl || '';
			$scope.pageRequest.search = searchFromUrl || '';
			$scope.pagindis = true;
			$scope.jobs = [];
			$scope.workflowNames = [];
			$scope.jobTypes = [];
			$scope.totalItems = 0;
			$scope.unsubscribe = new Rx.Subject();
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.changeUrl = false;
			$scope.toSearch = true;

			subscribeToCustomizeLabelsChange();
			getCompanyId();
		});

		$window.onpopstate = (...e) => {
			$scope.changeUrl = false;
			let searchFromUrl;
			if ($routeParams.search) {
				try {
					searchFromUrl = decodeURIComponent($routeParams.search);
					searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
				} catch (e) {
					searchFromUrl = '';
				}
				$scope.pageRequest.search = searchFromUrl || '';
				$scope.searchText = searchFromUrl || '';
			} else {
				$scope.pageRequest.search = '';
				$scope.searchText = '';
				$scope.toSearch = false;
			}
			getResultsPage(+$routeParams.page);
		};

		$scope.$on('$destroy', () => {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		$scope.$watch('selectActiveJobs', (newValue, oldValue) => {
			const initialPageNumber = 1;
			if (!oldValue || oldValue === newValue) {
				return false;
			} else if (newValue === 'Completed jobs') {
				setFilter('completed');
				$scope.pageRequest.pageOrder.reverse = true;
				$scope.pageRequest.pageOrder.predicate = 'startDate';
				$scope.pageRequest.filter = 'completed';
			} else if (newValue === 'Active jobs') {
				setFilter('active');
				$scope.pageRequest.pageOrder.reverse = false;
				$scope.pageRequest.pageOrder.predicate = 'startDate';
				$scope.pageRequest.filter = 'active';
			} else if (newValue === 'Active Jobs with Upcoming Shoots') {
				setFilter('activeWithShoots');
				$scope.pageRequest.pageOrder.reverse = false;
				$scope.pageRequest.pageOrder.predicate = 'startDate';
				$scope.pageRequest.filter = 'activeWithShoots';
			}
			getResultsPage(
				initialPageNumber,
				$scope.pageRequest.perPage,
				null,
				$scope.pageRequest.pageOrder.reverse
			);
		});

		let timerId;
		$scope.$watch('searchText', (newValue, oldValue) => {
			if (newValue == null) {
				return;
			}
			if (oldValue === newValue) {
				return;
			}
			if (!$scope.toSearch) {
				$scope.toSearch = true;
				return;
			}
			if (newValue.length > 0) {
				if (timerId != null) {
					clearTimeout(timerId);
				}
				timerId = setTimeout(searchRequest, 500);
			} else {
				clearTimeout(timerId);
				if (newValue.length === 0) {
					$scope.pageRequest.search = '';
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				}
			}
		});

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable
				.takeUntil($scope.unsubscribe)
				.subscribe(customizeLabels => {
					$scope.mainShootLabelName = customizeLabels.mainShootLabel;
					$scope.extraShootLabelName = customizeLabels.extraShootLabel;
					$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
				});
		}

		function getSelectActiveJobs() {
			const activeFilter = getDefaultFilter();
			let selectActiveOption;
			switch (activeFilter) {
				case 'active':
					selectActiveOption = $scope.selectActive[0];
					break;
				case 'activeWithShoots':
					selectActiveOption = $scope.selectActive[1];
					break;
				case 'completed':
					selectActiveOption = $scope.selectActive[2];
					break;
				default:
					selectActiveOption = $scope.selectActive[0];
			}

			return selectActiveOption;
		}

		function getCompanyId() {
			accountService.companyIdObservable
				.takeUntil($scope.unsubscribe)
				.subscribe(data => {
					$scope.companyId = data;
					$scope.selectActiveJobs = getSelectActiveJobs();
					$scope.pageRequest.filter = getDefaultFilter();
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				});
		}

		function getDefaultFilter() {
			const filter = $window.localStorage.getItem(
				`jobsOverviewFilter${$scope.companyId}`
			);

			return filter || setFilter();
		}

		function setFilter(optionFilter = 'active') {
			$window.localStorage.setItem(
				`jobsOverviewFilter${$scope.companyId}`,
				optionFilter
			);

			return optionFilter;
		}

		function searchRequest() {
			$scope.pageRequest.search = $scope.searchText;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		}

		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};
		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};
		$scope.showJob = function(id) {
			$location.path(`jobs/view/${id}`);
		};
		$scope.showInvoice = function(id) {
			$location.path(`invoices/invoice${id}`);
		};

		function getCurrentFilter() {
			return $scope.selectActiveJobs === 'Leads only';
		}

		function getResultsPage(
			pageNumber = null,
			perPage = null,
			predicate = null,
			reverse = null
		) {
			let changed = false;

			if (predicate) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = !!reverse;
				changed = true;
			}

			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}
			if (
				$scope.pageRequest &&
				$scope.totalItems !== 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}

			if (changed) {
				newJobsDataService
					.getJobsOnPage($scope.pageRequest, getCurrentFilter())
					.subscribe(
						data => successGetResultsPage(data),
						err => messageService.showDefaultErrorMessage(err)
					);
			}
		}
		function prepareJob(newJob) {
			$scope.clients = [];

			const {
				workflow,
				startDate,
				finishDate,
				primaryContact,
				secondaryContact
			} = $scope.newJob;

			$scope.newJob.oldWorkflow = workflow;

			if (!$scope.newJob.startDate) {
				$scope.newJob.hasNoDate = true;
			} else {
				$scope.dateFilterJob = 'dd/MM/yyyy';
				$scope.newJob.hasNoDate = false;
				$scope.newJob.startDate = timeService.createDateAsUTC(startDate);
				$scope.newJob.finishDate = timeService.createDateAsUTC(finishDate);
			}

			if (primaryContact) {
				const primaryClientSearchText = clientService.fillClientSearchText(
					primaryContact
				);
				$scope.clients[0] = primaryClientSearchText;
				$scope.newJob.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				const secondaryClientSearchText = clientService.fillClientSearchText(
					secondaryContact
				);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.newJob.secondaryContact = $scope.clients[1];
			}

			if (
				$scope.newJob.startDate &&
				($scope.newJob.startTime === null || $scope.newJob.finishTime === null)
			) {
				$scope.newJob.allday = true;
			}

			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames())
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.button_disable = false;
					$scope.isCreateJobSpinnningWheelActive = false;
				})
				.subscribe(() => {
					$timeout(() => {
						// $scope.newJob.type = type;
						$('#newJob').modal('show');
						$scope.isCreateJobSpinnningWheelActive = false;
						$scope.$broadcast('showModalJob', $scope.newJob);
					}, 300);
				});
		}

		$scope.editJobModal = function(index) {
			$scope.button_disable = true;
			$scope.newJob = angular.copy($scope.jobs[index]);
			prepareJob($scope.newJob);
			$scope.$evalAsync();
		};

		function successGetResultsPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
				$scope.pageRequest.search = $scope.searchText;
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.total : 0;

			let pagesCount;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (let i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}
			$scope.jobs = angular.copy(data.results);
			$rootScope.jobPageRequest = $scope.pageRequest;
			let newSearch;
			try {
				newSearch = encodeURIComponent($scope.pageRequest.search);
				newSearch = newSearch === 'undefined' ? null : newSearch;
			} catch (error) {
				newSearch = ''
			}
			if ($scope.changeUrl) {
				$location.search({
					page: $scope.pageRequest.page,
					search: newSearch || null
				});
			}
			$scope.changeUrl = true;
			$scope.$evalAsync();
		}
		$scope.showDeleteModal = jobId => {
			$scope.jobForDelete = jobId;
			$('#deleteModal').modal('show');
		};

		$scope.deleteJob = () => {
			$scope.deleteDisable = true;

			newJobsDataService
				.deleteJob($scope.jobForDelete)
				.finally(() => ($scope.deleteDisable = false))
				.subscribe(
					data => {
						messageService.showToaster('s_0', 'jobView');
						$('#deleteModal').modal('hide');
						getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
					},
					err => errorDeleteJob(err)
				);
		};

		function errorDeleteJob(error) {
			$('#deleteModal').modal('hide');
			messageService.handleError(error);
		}

		function getJobTypes() {
			return jobTypesDataService
				.getJobTypes()
				.map(data => successGetJobTypes(data));
		}

		function successGetJobTypes(data) {
			$scope.newJob.jobTypes = angular.copy(data);
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService
				.getWorkflowAndLanguageNames()
				.map(data => successGetWorkflowAndLanguageNames(data));
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.newJob.workflowNames = angular.copy(data.workflows);
			$scope.newJob.languageNames = angular.copy(data.languages);
			if ($scope.newJob.id) {
				$scope.newJob.workflow.name = stringModifierService.addSelectedText(
					$scope.newJob.workflow.name
				);
				const isWorkflowSaved = $scope.newJob.workflowNames.find(
					workflow => workflow.id === $scope.newJob.workflow.id
				);
				if ($scope.newJob.workflowNames && !isWorkflowSaved) {
					$scope.newJob.workflowNames.push($scope.newJob.workflow);
				}
			}
		}

		function showNewJobModal() {
			$timeout(() => {
				$('#newJob').modal('show');
				$scope.isCreateJobSpinnningWheelActive = false;
				$scope.$broadcast('showModalJob', $scope.newJob);
			}, 300);
		}
		$scope.getElement = function(index) {
			const tableId = document
				.getElementById('tableIdJob')
				.getBoundingClientRect();
			const dotsMenu = document
				.getElementById(`dotsMenuJob-${index}`)
				.getBoundingClientRect();
			const add = document.getElementsByClassName(`dropdown-job-${index}`);
			add[0].style.transform = '';
			// 81-height of modal;
			const x = dotsMenu.top - tableId.top;
			const value = tableId.height - x;
			if (tableId.height > 81 && value < 81) {
				add[0].style.transform = `translate(-15%, -${value}px)`;
			}
		};
		$scope.createJob = () => {
			delete $scope.newJob;
			$scope.isCreateJobSpinnningWheelActive = true;
			$scope.newJob = {};
			$scope.clients = [];

			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames())
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.isCreateJobSpinnningWheelActive = false;
				})
				.subscribe(() => {
					angular.forEach($scope.jobTypes, (value, key) => {
						if (value.default === true) {
							$scope.newJob.type = $scope.jobTypes[key];
						}
					});
					showNewJobModal();
				});
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/job/jobController.js